import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Container, Row, Col } from "react-bootstrap";
import { useContext, useEffect, useState } from 'react';
import StepOne from '../components/steps/StepOne';
import { StepTwo } from '../components/steps/StepTwo';
import { StepThree } from '../components/steps/StepThree';
import StepFour from '../components/steps/StepFour';
import Peymankaran from '../components/steps/Peymankaran';
import { MyContext } from '../components/helper/MyContext';
import { useNavigate } from 'react-router-dom';


function Register() {
    const [tab, setTab] = useState("1");
    const [isContractor, setIsContractor] = useState(false);
    const [dataOne, setDataOne] = useState(null);
    const [dataTwo, setDataTwo] = useState(null);
    const [dataThree, setDataThree] = useState(null);
    const [dataFour, setDataFour] = useState(null);

    const [type, setType] = useState(null);
    const [nationalCode, setNationalCode] = useState(null);
    const [idInternationalCode, setIdInternationalCode] = useState(null);
    const [economicCodeCompany, setEconomicCodeCompany] = useState(null);
    const [requestId, setRequestId] = useState(null);

    const { user } = useContext(MyContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/');
        }
    })


    const nextTab = () => {
        if (isContractor) {
            setTab("4")
        } else {
            setTab("5")
        }
    }
    const backTab = () => {
        if (isContractor) {
            setTab("4")
        } else {
            setTab("3")
        }
    }

    return (
        <Container className='mt-2 py-5'>
            <Row>
                <Col xs="12" style={{ fontSize: 14, lineHeight: 2, color: '#646464' }}>
                    <Tabs
                        defaultActiveKey={tab}
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        activeKey={tab}
                    >
                        <Tab eventKey="1" title="اطلاعات پایه" disabled={tab !== "1"}>
                            <StepOne
                                setType={(data) => setType(data)}
                                setNationalCode={(data) => setNationalCode(data)}
                                setIdInternationalCode={(data) => setIdInternationalCode(data)}
                                setEconomicCodeCompany={(data) => setEconomicCodeCompany(data)}
                                setData={(data) => setDataOne(data)}
                                changeStep={(e) => setTab(e)}
                                isContractor={isContractor}
                                handleContractor={(e) => setIsContractor(e)}
                                setRequestId={(e) => setRequestId(e)}
                            />
                        </Tab>
                        <Tab eventKey="2" title=" اسناد و مدارک" disabled={tab !== "2"}>
                            <StepTwo dataOne={dataOne} setData={(data) => setDataTwo(data)} changeStep={(e) => setTab(e)} />
                        </Tab>
                        <Tab eventKey="3" title="اطلاعات تکمیلی تامین کنندگان" disabled={tab !== "3"}>
                            <StepThree setData={(data) => setDataThree(data)} backStep={(e) => setTab(e)} changeStep={() => nextTab()} />
                        </Tab>
                        {
                            isContractor &&
                            <Tab eventKey="4" title="اطلاعات تکمیلی پیمانکاران" disabled={tab !== "4"}>
                                <Peymankaran setData={(data) => setDataFour(data)} backStep={(e) => setTab(e)} changeStep={() => setTab('5')} />
                            </Tab>
                        }
                        <Tab eventKey="5" title="ثبت نهایی" disabled={tab !== "5"}>
                            <StepFour
                                dataStepOne={dataOne}
                                dataStepTwo={dataTwo}
                                backStep={() => backTab()}
                                dataStepThree={dataThree}
                                dataStepFour={dataFour}
                                type={type}
                                nationalCode={nationalCode}
                                idInternationalCode={idInternationalCode}
                                economicCodeCompany={economicCodeCompany}
                                requestId={requestId}
                                step={tab}
                            />
                        </Tab>
                    </Tabs>

                </Col>
            </Row>
        </Container>
    );
}

export default Register;